<template>
    <div class="text-center system-text-color mb-5">
        <div
            class="school-info inline-flex flex md:flex-row flex-col items-center rounded-lg md:px-10 px-3 py-3"
            style="border: 2px solid var(--ui-primary-color)"
        >
            <i class="fas fa-exclamation-circle mr-2"></i>
            <div v-html="$t('overlay_unable_view_report')"></div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        document.addEventListener('click', e => {
            if (e.target.classList.contains('link-upgrade')) {
                this.$emit('open-payment')
            }
        })
    }
}
</script>

<style>
</style>